<template>
  <div class="roster-header-row" aria-hidden="true">
    <span class="roster-header-worker">Worker</span>
    <span class="roster-header-status">Status</span>
    <span class="roster-header-hours">Total Hours</span>
    <span class="roster-header-actions"></span>
  </div>
</template>

<script>
export default {
  name: 'TimesheetRosterHeader',
}
</script>

<style lang="scss" scoped>
.roster-header-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 90px 90px minmax(90px, auto);
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #f1f5f9;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr) 90px minmax(90px, auto);
  }
}

.roster-header-worker {
  padding-left: 54px;
}

.roster-header-status {
  @media (max-width: 900px) {
    display: none;
  }
}

.roster-header-hours {
  text-align: right;
}

@media (max-width: 575.98px) {
  .roster-header-row {
    display: none;
  }
}
</style>
